export default {"src":"/_next/static/media/0x385eeac5cb85a38a9a07a70c73e0a3271cfb54a7.10d74e02.svg","height":390,"width":390,"blurWidth":0,"blurHeight":0};